import { AxiosInstance, AxiosStatic } from "axios";
import { AxiosHookInjector, AxiosTransformerSetterOptions } from "../types";
import { toArray } from "../utils";
import {
  AxiosHandlerType,
  AxiosTransformerType,
  AxiosTransformer
} from "../../types";

export function mixinAxiosTransformer(
  axios: AxiosInstance | AxiosStatic,
  fn: AxiosTransformer,
  options?: Partial<AxiosTransformerSetterOptions>
) {
  let { pattern, refer, type } = {
    ...{
      type: AxiosHandlerType.request,
      pattern: "push"
    },
    ...options
  };
  const prop = AxiosTransformerType[type];
  const v = axios.defaults[prop];
  if (!v) {
    return [fn];
  }
  let transformers = Array.isArray(v) ? v : [v];
  // 一个 transformer 不允许多次注册
  transformers = transformers.filter(i => i !== fn);

  if (pattern === "after" || pattern === "before") {
    let index = refer ? transformers.indexOf(refer) : -1;
    if (index < 0) {
      transformers.push(fn);
    } else {
      if (pattern === "after") index += 1;
      transformers.splice(index, 0, fn);
    }
  } else {
    transformers[pattern](fn);
  }
  return transformers;
}

export const injectAxiosTransformerHook: AxiosHookInjector = ({
  axios,
  type,
  hook
}) => {
  if (!hook.transformer) return;
  const items = toArray(hook.transformer[type]);
  const prop = AxiosTransformerType[type];
  for (let item of items) {
    const fn = typeof item === "function" ? item : item.fn;
    const options = typeof item === "function" ? {} : item.options;
    axios.defaults[prop] = mixinAxiosTransformer(axios, fn, {
      ...options,
      type
    });
  }
};
